import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HttpErrorResponse } from '@angular/common/http';
import { CertificateModalSignatureData } from '../../../shared/services/signature-nca-common-utils.service';
import { ErrorService, throwNormalizedError } from '../../../core/services/error.service';
import { AuthApiService } from '../../../core/modules/auth/auth-api.service';

@UntilDestroy()
@Component({
  selector: 'tax-login-by-eds',
  templateUrl: 'login-by-eds.component.html',
  styleUrls: [],
})

export class LoginByEdsComponent {
  constructor(
    private authApiService: AuthApiService,
    private router: Router,
    private errorService: ErrorService,
  ) {
  }

  login(data: CertificateModalSignatureData): void {
    // @ts-ignore
    this.authApiService.loginBySignature(data.signature.signingDocument)
      .pipe(
        throwNormalizedError(),
        untilDestroyed(this),
      )
      .subscribe({
        next: () => this.router.navigate(['main/kkms']),
        error: (response: HttpErrorResponse) => {
          this.errorService.errorType = response.error?.ofdErrorCode;
        },
      });
  }
}
